import React from 'react'
import styled from 'styled-components'
import BoostAnotherAction from '../FarmTable/Actions/BoostAnotherAction'
import XVVSBoostAction from '../FarmTable/Actions/XVVSBoostAction'
import NFTBoostAction from '../FarmTable/Actions/NFTBoostAction'

export interface BoostPanelProps {
  isBoosted: boolean
  isLoading: boolean
  boostMultiplier: number
  farmId?: number
  xVVSStaked?: boolean
}

const Container = styled.div`
  overflow: hidden;
  background: ${({ theme }) => theme.colors.boostlightAquaBackground};
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 24px;
  gap: 24px;
`

const BoostPanel: React.FunctionComponent<BoostPanelProps> = ({
  farmId,
  boostMultiplier,
  isLoading,
  isBoosted,
  xVVSStaked = false,
}) => {
  return (
    <Container>
      <BoostAnotherAction
        farmId={farmId}
        boostMultiplier={boostMultiplier}
        isBoosted={isBoosted}
        isLoading={isLoading}
      />
      <XVVSBoostAction disabled={!xVVSStaked} />
      <NFTBoostAction farmId={farmId} disabled={!isBoosted || !xVVSStaked} />
    </Container>
  )
}

export default BoostPanel
